@import '../../app-brand/entities/entity-layer.module.less';

.smart-fill-container {
  border: 1px solid transparent;
  border-image-slice: 1;
  border-radius: 4px;
  background-image: @ship-ai--input--gradient-border-image;
  background-origin: border-box;
  background-clip: content-box, border-box;

  > label {
    background: @ship-ai--input--background-color;
  }

  > input {
    background: @ship-ai--input--background-color;
  }

  > div {
    background: @ship-ai--input--background-color;
  }
}

.smart-fill {
  border: 0 solid transparent;
  background: @ship-ai--input--background-color;
  border-radius: 3px;

  > label {
    background: @ship-ai--input--background-color;
  }

  > input {
    background: @ship-ai--input--background-color;
  }

  > div {
    background: @ship-ai--input--background-color;
  }
}
